import { useAnimationFrame } from '../utils/use-animation-frame.mjs';
import { useMotionValue } from './use-motion-value.mjs';

function useTime() {
    var time = useMotionValue(0);
    useAnimationFrame(function (t) { return time.set(t); });
    return time;
}

export { useTime };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/value/use-time.mjs
// module id = BWdG
// module chunks = 0